export default __webpack_public_path__ + "static/media/something-went-wrong.e4b8a6a3.svg";